import {
  WSActions,
  WSFlexBox,
  WSForm,
  WSInputNumber,
  WSInputText
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import * as Yup from "yup";
import { FormFieldSelectPayeeEngagement } from "../../../modules/Payees/components/SelectPayeeEngagement/FormField";

type FormData = {
  payee: {
    payeeId: string;
    payerPayeeEngagementId: string;
  } | null;
  description: string;
  amount: number | null;
};

type Props = {
  defaultValues?: FormData;
  onClose: () => void;
  onSubmit: (values: FormData) => void;
  onDelete?: () => void;
  invoiceCurrency: Currency;
};

export const ModalInvoiceCollaboratorForm: React.FC<Props> = ({
  defaultValues,
  onClose,
  onSubmit,
  onDelete,
  invoiceCurrency
}) => {
  return (
    <WSForm<FormData>
      defaultValues={
        defaultValues || {
          payee: null,
          description: "",
          amount: null
        }
      }
      validationSchema={Yup.object().shape({
        payee: Yup.object().shape({
          payeeId: Yup.string().required("Required"),
          payerPayeeEngagementId: Yup.string().required("Required")
        }),
        description: Yup.string().required("Required"),
        amount: Yup.number().nullable().required("Required")
      })}
      onSubmit={values => {
        onSubmit(values);
        onClose();
      }}
    >
      <WSFlexBox direction="column" gap="M">
        <FormFieldSelectPayeeEngagement name="payee" />
        <WSForm.Field
          name="description"
          label="Description"
          component={WSInputText}
        />
        <WSForm.Field
          name="amount"
          label="Amount"
          component={WSInputNumber}
          componentProps={{
            currency: invoiceCurrency,
            maxFractionDigits: 2
          }}
        />
      </WSFlexBox>

      <WSActions
        mt="L"
        buttons={[
          {
            kind: "Secondary",
            label: "Delete item",
            destructive: true,
            onClick: () => {
              onDelete?.();
              onClose();
            },
            type: "button",
            visible: !!onDelete
          },
          {
            kind: "Secondary",
            label: "Cancel",
            onClick: onClose,
            type: "button"
          },
          {
            kind: "Primary",
            label: "Save",
            type: "submit"
          }
        ]}
      />
    </WSForm>
  );
};
